<template>
  <div class="p-6">
    <div class="text-center py-12">
      <i class="pi pi-share-alt text-4xl text-gray-400 mb-4"></i>
      <p class="text-gray-500 mb-2">Dependencies & Relationships</p>
      <p class="text-sm text-gray-400">
        Dependency visualization will be displayed here.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Section } from '@/types/ashmatics';

defineProps<{
  section: Section | null;
}>();
</script>
